import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const RecordingModalChannelContainer = styled.div<React.CSSProperties>`
  bottom: ${646 * Screen.widthRatio}px;
  display: flex;
  flex-direction: column;
  height: fit-content;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

export default RecordingModalChannelContainer;
